<script lang="ts">
  // libs
  import { EventTracking } from "@shared/services/event_tracking/events";

  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import OrderPricing from "@retailer/svelte/Cart/Page/Components/OrderPricing.svelte";
  import OrderTotal from "@retailer/svelte/Cart/Page/Components/OrderTotal.svelte";

  // services
  import {
    getContainerCountString,
    getCartContainerCount,
  } from "@retailer/services/order_quantities_service";

  // stores
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  // types
  import type { CartType } from "@shared/types/Cart";
  import { CartOrderSummaryEntity } from "@shared/services/event_tracking/entities";

  // props
  export let cart: CartType;

  // data
  let isOpen = false;
  const { trackClick } = EventTracking;

  // functions
  const onClickAccordion = () => {
    isOpen = !isOpen;
    const eventType = isOpen ? "expand_accordion" : "collapse_accordion";
    trackClick(eventType, new CartOrderSummaryEntity({ orderGroupId: cart.id }));
  };

</script>

{#if $LayoutStore.isMobile}
  <details
    class="fizz-accordion"
    on:click={onClickAccordion}
    on:keypress={onClickAccordion}
    data-testid="order-summary-accordion"
  >
    <summary class="fizz-inset-square-16">
      <h4 class="fizz-heading-4"><FormatMoney input={cart.total} /></h4>
      <p class="fizz-text-subdued fizz-text-small">
        {getContainerCountString(getCartContainerCount(cart))}
      </p>
    </summary>
    <div class="fizz-border-bottom fizz-inset-square-16 fizz-border-top">
      <OrderPricing {cart} />
    </div>
    <OrderTotal {cart} />
  </details>
{:else}
  <div class="fizz-flow-8 fizz-border-bottom fizz-stack-16">
    <div class="fizz-stack-12 fizz-flow-8">
      <OrderPricing {cart} />
    </div>
  </div>
  <OrderTotal {cart} />
{/if}
